import * as Sentry from '@sentry/react';
import { replayIntegration } from '@sentry/react';

const SENTRY_ENABLED = process.env.REACT_APP_SENTRY_ENABLED === 'true';

export function initSentry() {
  if (!SENTRY_ENABLED || !process.env.REACT_APP_SENTRY_DSN) {
    console.log('[Sentry] Disabled - no DSN or not enabled');
    return;
  }

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,

    integrations: [
      replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        mask: ['.credit-card', '[data-sensitive]'],
        block: ['#password-field', '[data-no-record]'],
        networkDetailAllowUrls: [window.location.origin],
      }),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

// Direct Sentry access (no wrapper)
export const sentry = SENTRY_ENABLED
  ? Sentry
  : {
      captureException: () => {
        return;
      },
      setUser: () => {
        return;
      },
    };
